import RenderQRCodeAndCopyButton from '@atoms/RenderQRCodeAndCopyButton';
import QrCodeScanner from '@mui/icons-material/QrCodeScanner';
import { Button, Dialog, Stack, Typography } from '@mui/material';
import { useState } from 'react';

export default function ViewQRModal({ text }: { text: string }) {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Button
                onClick={() => setShowModal(true)}
                startIcon={<QrCodeScanner sx={{ marginRight: 1 }} />}
                sx={{ textTransform: 'none' }}
                variant="outlined"
            >
                <Typography>View QR Code</Typography>
            </Button>
            <Dialog open={showModal} onClose={() => setShowModal(false)} maxWidth="lg">
                <Stack padding={8}>
                    <RenderQRCodeAndCopyButton label="Copy Sign Up QR Code" text={text} />
                </Stack>
            </Dialog>
        </>
    );
}
